import { ajvResolver } from '@hookform/resolvers/ajv'
import { useAlert } from 'contexts/alert'
import { useAuth } from 'contexts/auth'
import { useCustomTheme } from 'contexts/theme'
import { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import SignUpMultipleSchema, { ISignUpMultipleFormData } from 'schema/authentication/sign-up-multiple'
import api from 'services/api'

interface UseComponentProps {
  token: string
}

const UseComponent = ({ token }: UseComponentProps) => {
  const [disabled, setDisabled] = useState(true)
  const [hasToken, setHasToken] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isPasswordHidden, setIsPasswordHidden] = useState(true)
  const [isHidePasswordRequirements, setIsHidePasswordRequirements] = useState(false)

  const { signIn } = useAuth()
  const { theme, onChangeThema } = useCustomTheme()
  const { openAlert, closeAlert } = useAlert()

  const history = useHistory()

  const form = useForm<ISignUpMultipleFormData>({
    resolver: ajvResolver(SignUpMultipleSchema),
  })

  const loadData = async () => {
    try {
      setHasToken(true)

      const { data } = await api.get(`/invites/by-token/${token}`)

      const content = data.data
      form.setValue('token', token)
      form.setValue('organizationId', content.organizationIdRequest)
      form.setValue('email', content.invitedEmail)

      // Aplica o tema da organização se existir
      if (content.theme) {
        // Garante que as cores tenham # no início
        const normalizedTheme = {
          primary: content.theme.primary?.includes('#') ? content.theme.primary : `#${content.theme.primary}`,
          secondary: content.theme.secondary?.includes('#') ? content.theme.secondary : `#${content.theme.secondary}`,
          terciary: content.theme.terciary?.includes('#') ? content.theme.terciary : `#${content.theme.terciary}`,
          baseLogo: content.theme.baseLogo,
          blackLogo: content.theme.blackLogo,
          whiteLogo: content.theme.whiteLogo,
        }
        onChangeThema(normalizedTheme)
      }
    } catch (error) {
      setHasToken(false)
      history.push('/')
    }
  }

  const handleChange = (formField: any) => closeAlert()

  const onSubmit = useCallback(
    async (payLoad: ISignUpMultipleFormData) => {
      try {
        setIsLoading(true)

        await api.post('/users', payLoad).then((res) => {
          const { data } = res.data
          payLoad['userId'] = data.id
        })

        await api.post('/passwords/email-confirmation', payLoad)

        await signIn({
          userId: payLoad.userId,
          email: payLoad.email,
          password: payLoad.password,
        })

        setIsLoading(false)

        history.push('/redirect')
      } catch (err) {
        setIsLoading(false)
        openAlert('Erro ao criar nova conta!', 'error')
      }
    },
    [history]
  )

  useEffect(() => {
    if (token) {
      loadData()
    }
  }, [])

  return {
    form,
    theme,
    isLoading,
    hasToken,
    isPasswordHidden,
    disabled,
    onSubmit,
    isHidePasswordRequirements,
    handleChange,
    setIsHidePasswordRequirements,
    setDisabled,
    setIsPasswordHidden,
  }
}

export default UseComponent
